export function parseDelimitedItems(raw) {
  return String(raw || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [title, ...rest] = line.split("|");
      return {
        title: (title || "").trim(),
        body: rest.join("|").trim(),
      };
    })
    .filter((item) => item.title && item.body);
}

export function parseSimpleList(raw) {
  return String(raw || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
}

export function parseRecordItems(raw, keys) {
  return String(raw || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const parts = line.split("|");
      const item = {};
      keys.forEach((key, index) => {
        item[key] = (parts[index] || "").trim();
      });
      return item;
    })
    .filter((item) => keys.every((key) => item[key]));
}

export function parseKeyValueMap(raw) {
  return parseRecordItems(raw, ["key", "value"]).reduce((acc, item) => {
    acc[item.key] = item.value;
    return acc;
  }, {});
}
